/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsApiHistoryItem,
    ControlcenterMelcoModelsApiHistoryItemFromJSON,
    ControlcenterMelcoModelsApiHistoryItemFromJSONTyped,
    ControlcenterMelcoModelsApiHistoryItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsPaymentTransDetails
 */
export interface ControlcenterMelcoModelsPaymentTransDetails {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    product_level_code?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    payment_entry_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    qty?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    service_start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    service_end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    transaction_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    processing_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    desc?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    payment_status?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    affiliate_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    affiliate_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    acc_resource_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    payment_mode?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    payment_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    country_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    org_unit?: string | null;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsApiHistoryItem>}
     * @memberof ControlcenterMelcoModelsPaymentTransDetails
     */
    api_history_list?: Array<ControlcenterMelcoModelsApiHistoryItem> | null;
}

export function ControlcenterMelcoModelsPaymentTransDetailsFromJSON(json: any): ControlcenterMelcoModelsPaymentTransDetails {
    return ControlcenterMelcoModelsPaymentTransDetailsFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsPaymentTransDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsPaymentTransDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'product_level_code': !exists(json, 'product_level_code') ? undefined : json['product_level_code'],
        'payment_entry_date': !exists(json, 'payment_entry_date') ? undefined : (new Date(json['payment_entry_date'])),
        'price': !exists(json, 'price') ? undefined : json['price'],
        'qty': !exists(json, 'qty') ? undefined : json['qty'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'service_start_date': !exists(json, 'service_start_date') ? undefined : (new Date(json['service_start_date'])),
        'service_end_date': !exists(json, 'service_end_date') ? undefined : (new Date(json['service_end_date'])),
        'transaction_id': !exists(json, 'transaction_id') ? undefined : json['transaction_id'],
        'processing_date': !exists(json, 'processing_date') ? undefined : (json['processing_date'] === null ? null : new Date(json['processing_date'])),
        'desc': !exists(json, 'desc') ? undefined : json['desc'],
        'payment_status': !exists(json, 'payment_status') ? undefined : json['payment_status'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'affiliate_code': !exists(json, 'affiliate_code') ? undefined : json['affiliate_code'],
        'affiliate_name': !exists(json, 'affiliate_name') ? undefined : json['affiliate_name'],
        'acc_resource_id': !exists(json, 'acc_resource_id') ? undefined : json['acc_resource_id'],
        'payment_mode': !exists(json, 'payment_mode') ? undefined : json['payment_mode'],
        'payment_amount': !exists(json, 'payment_amount') ? undefined : json['payment_amount'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
        'org_unit': !exists(json, 'org_unit') ? undefined : json['org_unit'],
        'api_history_list': !exists(json, 'api_history_list') ? undefined : (json['api_history_list'] === null ? null : (json['api_history_list'] as Array<any>).map(ControlcenterMelcoModelsApiHistoryItemFromJSON)),
    };
}

export function ControlcenterMelcoModelsPaymentTransDetailsToJSON(value?: ControlcenterMelcoModelsPaymentTransDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'melco_customer_id': value.melco_customer_id,
        'user_name': value.user_name,
        'product_code': value.product_code,
        'product_level_code': value.product_level_code,
        'payment_entry_date': value.payment_entry_date === undefined ? undefined : (value.payment_entry_date.toISOString()),
        'price': value.price,
        'qty': value.qty,
        'amount': value.amount,
        'service_start_date': value.service_start_date === undefined ? undefined : (value.service_start_date.toISOString()),
        'service_end_date': value.service_end_date === undefined ? undefined : (value.service_end_date.toISOString()),
        'transaction_id': value.transaction_id,
        'processing_date': value.processing_date === undefined ? undefined : (value.processing_date === null ? null : value.processing_date.toISOString()),
        'desc': value.desc,
        'payment_status': value.payment_status,
        'comments': value.comments,
        'affiliate_code': value.affiliate_code,
        'affiliate_name': value.affiliate_name,
        'acc_resource_id': value.acc_resource_id,
        'payment_mode': value.payment_mode,
        'payment_amount': value.payment_amount,
        'country_code': value.country_code,
        'org_unit': value.org_unit,
        'api_history_list': value.api_history_list === undefined ? undefined : (value.api_history_list === null ? null : (value.api_history_list as Array<any>).map(ControlcenterMelcoModelsApiHistoryItemToJSON)),
    };
}


